module.exports = __webpack_public_path__ + "img/hr-green-asterisk-01.900ee6d6.png";